<ngb-alert [hidden]="!show" [type]="type" (closed)="close()">
  You've used {{ percentUsed }}% of your monthly error quota. Your quota will
  reset in {{ daysRemaining }} days.
  <a class="alert-link" href="/account/plan/edit" target="_self">
    Upgrade your plan now
  </a>
</ngb-alert>
